import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';

export default function ForgotPasswordEmailForm({ setPage }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const API_BASE_URL = window._config?.apiBaseUrl || '';
  const DATABASE_KEY = window._config?.databaseKey || '';
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(
  `${API_BASE_URL}/ResendOtp?Mail=${encodeURIComponent(email)}&databaseKey=${encodeURIComponent(DATABASE_KEY)}`
);
      const data = await response.json();
      const result = data?.ResendOtpjs?.Table?.[0];

      if (result?.Status === 'Success') {
        // Go to email verification with reset mode
        setPage({ name: 'forgot', email });  // This sends the real entered email
      } else {
        setError(result?.Message || 'Failed to send OTP. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setError('Something went wrong. Try again later.');
    } finally {
      setLoading(false);
    }
  };

 return (
  <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-100 via-rose-50 to-teal-100 px-4 py-10 overflow-hidden">

    {/* Decorative Flowers */}
    <div className="absolute top-16 left-12 text-6xl opacity-20 animate-bounce">🌸</div>
    <div className="absolute bottom-20 right-16 text-5xl opacity-20 animate-pulse">🌷</div>

    <div className="backdrop-blur-xl bg-white/70 shadow-2xl rounded-3xl p-8 w-full max-w-md border border-white/40 transition-all duration-500">

      {/* Header */}
      <div className="text-center mb-6">
        <Mail className="text-teal-600 h-14 w-14 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-teal-700">
          Reset Your Password
        </h2>
        <p className="text-gray-600 text-sm mt-2">
          Enter your registered email to receive an OTP
        </p>
      </div>

      {/* Error Message */}
      {error && (
        <div className="text-sm text-red-700 bg-red-100 p-3 rounded-xl mb-4">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Email Input */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Mail className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email address"
            className="w-full px-3 py-3 pl-12 border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition"
            required
          />
        </div>

        {/* Button */}
        <button
          type="submit"
          disabled={loading}
          className={`w-full flex justify-center items-center gap-2 py-3 rounded-xl font-semibold text-white shadow-lg transition transform ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-teal-500 to-rose-400 hover:scale-105"
          }`}
        >
          {loading ? "Sending OTP..." : "Continue"}
          {!loading && <ArrowRight className="h-4 w-4" />}
        </button>
      </form>

      {/* Back to Login */}
      <div className="text-center text-sm mt-6">
        Remember your password?{" "}
        <button
          onClick={() => setPage("login")}
          className="font-medium text-rose-500 hover:underline"
        >
          Sign In
        </button>
      </div>

    </div>
  </div>
);
}
